import { render } from "./OpportunityCard.vue?vue&type=template&id=2091e69e&lang=true"
import script from "./OpportunityCard.vue?vue&type=script&lang=js"
export * from "./OpportunityCard.vue?vue&type=script&lang=js"

import "./OpportunityCard.vue?vue&type=style&index=0&id=2091e69e&lang=css"
script.render = render

export default script